<template>
  <div class="attempt-wrapper">
    <h3>Previous Attempts</h3>
    <div class="attempt" v-for="attempt in attempts" :key="attempt.id">
      <div class="attempt-name">
        <SuccessIcon v-if="attempt.resolved" />
        <FailIcon v-if="!attempt.resolved" />
        <span
          >{{
            attempt.resolved ? 'Successful attempt on' : 'Failed attempt on'
          }}
          {{ attempt.created | formatDate }}</span
        >
      </div>
      <div class="prism-code">
        <prism :language="exercise.language">{{
          attempt.submitted_code
        }}</prism>
      </div>
    </div>
    <slot v-if="!loading && attempts && !attempts.length" name="no-attempts" />
    <ActionLoader
      v-if="loading"
      name="ball-clip-rotate"
      loaderClass="level__loading-spinner"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import Prism from 'vue-prism-component'
import SuccessIcon from '@/assets/icons/course/exercise/success-icon.svg'
import FailIcon from '@/assets/icons/course/exercise/fail-icon.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'Attempts',
  components: {
    SuccessIcon: { ...SuccessIcon, name: 'SuccessIcon' },
    FailIcon: { ...FailIcon, name: 'FailIcon' },
    Prism,
    ActionLoader,
  },
  filters: {
    formatDate(date) {
      // November 17, 2020 8:47 PM
      return format(new Date(date), 'LLLL d, yyyy hh:mm a')
    },
  },
  props: {
    exercise: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      attempts: state => state.exercises.previousAttempts,
    }),
  },
  methods: {
    async getAttempts() {
      this.loading = true
      await this.$store.dispatch(
        'exercises/getExerciseAttemptsByExerciseId',
        this.exercise.id
      )
      this.loading = false
    },
  },
  async mounted() {
    await this.getAttempts()
  },
  watch: {
    exercise(newValue) {
      this.getAttempts()
    },
  },
}
</script>
<style lang="scss" scoped>
.attempt-wrapper {
  padding: 15px 35px;
  h3 {
    font-size: 20px;
    margin-top: 0px;
  }
  .attempt {
    margin-bottom: 40px;
    .attempt-name {
      display: flex;
      align-content: center;
      span {
        margin-left: 15px;
      }
    }
  }

  .prism-code {
    background-color: #000000;
    font-size: 0.8em;
    margin-top: 15px;
    margin-bottom: 10px;
    padding: 20px 0px;
    border: 1px solid #424040;
  }
}
</style>
